import React from 'react'

export const FilledAddSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1871:268121)">
        <path
          d="M84 40C84 50.6087 79.7857 60.7828 72.2843 68.2843C64.7828 75.7857 54.6087 80 44 80C33.3913 80 23.2172 75.7857 15.7157 68.2843C8.21427 60.7828 4 50.6087 4 40C4 29.3913 8.21427 19.2172 15.7157 11.7157C23.2172 4.21427 33.3913 0 44 0C54.6087 0 64.7828 4.21427 72.2843 11.7157C79.7857 19.2172 84 29.3913 84 40ZM46.5 22.5C46.5 21.837 46.2366 21.2011 45.7678 20.7322C45.2989 20.2634 44.663 20 44 20C43.337 20 42.7011 20.2634 42.2322 20.7322C41.7634 21.2011 41.5 21.837 41.5 22.5V37.5H26.5C25.837 37.5 25.2011 37.7634 24.7322 38.2322C24.2634 38.7011 24 39.337 24 40C24 40.663 24.2634 41.2989 24.7322 41.7678C25.2011 42.2366 25.837 42.5 26.5 42.5H41.5V57.5C41.5 58.163 41.7634 58.7989 42.2322 59.2678C42.7011 59.7366 43.337 60 44 60C44.663 60 45.2989 59.7366 45.7678 59.2678C46.2366 58.7989 46.5 58.163 46.5 57.5V42.5H61.5C62.163 42.5 62.7989 42.2366 63.2678 41.7678C63.7366 41.2989 64 40.663 64 40C64 39.337 63.7366 38.7011 63.2678 38.2322C62.7989 37.7634 62.163 37.5 61.5 37.5H46.5V22.5Z"
          fill="#3E4685"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1871:268121"
          x="0"
          y="0"
          width="88"
          height="88"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          {/* <feFlood
            flood-opacity="0"
            result="BackgroundImageFix"
            />
            <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
            />
          <feOffset dy="4" /> */}
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.708264 0 0 0 0 0.716722 0 0 0 0 0.783333 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1871:268121"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1871:268121"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
